module.exports = __webpack_public_path__ + "img/line-white-long-swoop.d046f60f.png";